export default __webpack_public_path__ + "static/media/avatar_pyper5.0f12e9ff.mp3";